<div
    [class]="{
        'loader-container': true,
        'content-loader': contentLoader,
    }"
>
    <nz-icon nzType="loading" nzTheme="outline"></nz-icon>
</div>
